import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useClearLocalStorageOnPathChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const clearLocalStorage = () => {
      localStorage.removeItem('orderBy');
      localStorage.removeItem('orderByDesc');
      localStorage.removeItem('procurementPage');
      localStorage.removeItem('procurementDetailsPage');
      localStorage.removeItem('brandsPage');
      localStorage.removeItem('categoriesPage');
      localStorage.removeItem('productsPage');
      localStorage.removeItem('suppliersPage');
      localStorage.removeItem('usersPage');
      localStorage.removeItem('locationsPage');
      localStorage.removeItem('locationDetailsPage');
      localStorage.removeItem('salesInvoicePage');
    };

    return () => {
      clearLocalStorage();
    };
  }, [pathname]);
};

export default useClearLocalStorageOnPathChange;
